<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <div class="page-title">
        <el-button size="mini" @click="$router.back()">返回</el-button>
        <span>{{ isAllJoinList ? '总报名记录' : '报名记录' }}</span>
        <span v-if="!isAllJoinList" class="order-tip">标题：{{ orderTitle || '-' }}</span>
      </div>

      <el-form :inline="true" :model="searchCondition" class="search-form">
        <el-form-item label="用户昵称">
          <el-input v-model="searchCondition.fullname" placeholder="请输入用户昵称" clearable></el-input>
        </el-form-item>
        <el-form-item label="报名手机号">
          <el-input v-model="searchCondition.join_mobile" placeholder="请输入报名手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="报名状态">
          <el-select v-model="searchCondition.join_status" placeholder="请选择报名状态" clearable>
            <el-option v-for="item in joinOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名时间">
          <DatePicker :value="dateRange" @dataSearch="dataSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchButton">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="{ background: '#fbfbfb' }">
        <el-table-column prop="fullname" label="用户昵称" align="center"></el-table-column>
        <el-table-column prop="join_mobile" label="报名手机号" align="center"></el-table-column>
        <el-table-column prop="joined_at" label="报名时间" align="center"></el-table-column>
        <el-table-column label="报名状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="joinTagType(scope.row.join_status)">{{ joinStatusText(scope.row.join_status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="audit_time" label="审核时间" align="center"></el-table-column>
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="category_type" label="短剧类型" align="center"></el-table-column>
        <el-table-column label="订单封面" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.cover" class="cover-img" :src="scope.row.cover" @click="previewCover(scope.row.cover)" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.join_status == 0" size="mini" type="primary" @click="openAudit(scope.row)">报名审核</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>

      <el-dialog title="报名审核" :visible.sync="auditVisible" width="420px">
        <el-form :model="auditForm" label-width="90px">
          <el-form-item label="审核结果">
            <el-radio-group v-model="auditForm.join_status">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="auditVisible = false">取 消</el-button>
          <el-button type="primary" :loading="auditSubmitting" @click="submitAudit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import DatePicker from '@/components/DatePicker.vue'

export default {
  name: 'KhlAiOrderJoinList',
  components: {
    PageHeaderLayout,
    DatePicker
  },
  data() {
    return {
      loading: false,
      auditSubmitting: false,
      tableData: [],
      orderTitle: '',
      dateRange: [],
      searchCondition: {
        ai_order_id: ''
      },
      page: {
        current_page: 1,
        page_size: 10,
        total: 0
      },
      joinOptions: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核拒绝', value: 2 }
      ],
      auditVisible: false,
      auditForm: {
        id: '',
        join_status: 1
      }
    }
  },
  created() {
    this.searchCondition.ai_order_id = this.$route.query.ai_order_id || ''
    this.orderTitle = this.$route.query.title || ''
    this.init()
  },
  computed: {
    isAllJoinList() {
      return !this.searchCondition.ai_order_id
    }
  },
  methods: {
    searchButton() {
      this.page.current_page = 1
      this.init()
    },
    resetSearch() {
      this.searchCondition = {
        ai_order_id: this.$route.query.ai_order_id || ''
      }
      this.dateRange = []
      this.searchButton()
    },
    dataSearch(value) {
      this.dateRange = value || []
      if (this.dateRange.length) {
        this.searchCondition.start_time = this.dateRange[0]
        this.searchCondition.end_time = this.dateRange[1]
      } else {
        delete this.searchCondition.start_time
        delete this.searchCondition.end_time
      }
    },
    handleSizeChange(val) {
      this.page.page_size = val
      this.page.current_page = 1
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current_page = val
      this.init()
    },
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.ai_order_id) {
        condition.ai_order_id = this.searchCondition.ai_order_id
      }
      ['join_mobile', 'fullname', 'start_time', 'end_time'].forEach(key => {
        if (this.searchCondition[key]) {
          condition[key] = this.searchCondition[key]
        }
      })
      if (this.searchCondition.join_status === 0 || this.searchCondition.join_status) {
        condition.join_status = this.searchCondition.join_status
      }
      return condition
    },
    async init() {
      this.loading = true
      let params = Object.assign({}, this.handleSearchCondition(), {
        current_page: this.page.current_page,
        page_size: this.page.page_size
      })
      try {
        let res = await this.$api.getKhlAiOrderJoinList(params)
        this.tableData = res.data || []
        this.page = Object.assign({}, this.page, res.pages || {})
      } finally {
        this.loading = false
      }
    },
    openAudit(row) {
      this.auditForm = {
        id: row.id,
        join_status: 1
      }
      this.auditVisible = true
    },
    async submitAudit() {
      this.auditSubmitting = true
      try {
        let result = await this.$api.auditKhlAiOrderJoin(this.auditForm)
        if (result) {
          this.$message.success('审核成功')
          this.auditVisible = false
          this.init()
        } else {
          this.$message.warning('未更新审核状态')
        }
      } finally {
        this.auditSubmitting = false
      }
    },
    previewCover(url) {
      window.open(url, '_blank')
    },
    joinStatusText(status) {
      let item = this.joinOptions.find(option => option.value == status)
      return item ? item.label : '-'
    },
    joinTagType(status) {
      if (status == 1) {
        return 'success'
      }
      if (status == 2) {
        return 'danger'
      }
      return 'warning'
    }
  }
}
</script>

<style scoped lang="scss">
.main-page-content {
  background: #fff;
  padding: 20px;
  padding-bottom: 60px;
}

.page-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: bold;
}

.page-title .el-button {
  margin-right: 12px;
}

.order-tip {
  margin-left: 16px;
  color: #909399;
  font-size: 13px;
  font-weight: normal;
}

.search-form {
  margin-bottom: 12px;
}

.cover-img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
}

.pagination {
  float: right;
  margin-top: 20px;
}
</style>
